import { useStatsigClient } from '@statsig/react-bindings';
import { dynamicConfigs } from '../../utils/statsig';

export const useSavedListNewBadge = () => {
    const { client } = useStatsigClient();
    const { expiresAtUtc } = client.getDynamicConfig(dynamicConfigs.SAVED_PLAYER_LIST_NEW_BADGE)?.value || {};

    const expiresAt = Date.parse(expiresAtUtc);
    return Number.isFinite(expiresAt) && Date.now() < expiresAt;
};
